import React from 'react';
import { Calendar } from 'primereact/calendar';

const ProfileMentoringForm = ({ isOpen, onClose, onSubmit, formData, setFormData, isEditing }) => {
    if (!isOpen) return null;

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleDateChange = (name, dateObj) => {
        let dateString = '';
        if (dateObj) {
            const yyyy = dateObj.getFullYear();
            const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
            dateString = `${yyyy}-${mm}`;
        }
        handleChange({ target: { name, value: dateString } });
    };

    return (
        <div className="modal-overlay" style={{ zIndex: 1000 }}>
            <div className="modal-box form-modal-box" style={{ maxHeight: '90vh', overflowY: 'auto' }}>

                <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <h3 style={{ margin: 0, paddingRight: '15px', lineHeight: '1.4' }}>
                        {isEditing ? "Cập nhật Thông tin hướng dẫn" : "Thêm mới Thông tin hướng dẫn"}
                    </h3>
                    <button
                        type="button"
                        className="close-btn"
                        onClick={onClose}
                        style={{ fontSize: '26px', lineHeight: '1', display: 'flex', flexShrink: 0, marginTop: '-2px' }}
                    >
                        &times;
                    </button>
                </div>

                <div className="modal-body" style={{ padding: '25px' }}>
                    <form id="mentoringForm" onSubmit={onSubmit}>
                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Họ tên NCS/Học viên (*)</label>
                            <input type="text" name="StudentName" className="form-input" value={formData.StudentName || ''} onChange={handleChange} required />
                        </div>

                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Trình độ (*)</label>
                            <input type="text" name="EducationLevel" className="form-input" value={formData.EducationLevel || ''} onChange={handleChange} required />
                        </div>

                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Tên đề tài (*)</label>
                            <input type="text" name="TopicName" className="form-input" value={formData.TopicName || ''} onChange={handleChange} required />
                        </div>

                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Tên Trường (*)</label>
                            <input type="text" name="SchoolName" className="form-input" value={formData.SchoolName || ''} onChange={handleChange} required />
                        </div>

                        <div className="form-grid-2" style={{ marginBottom: '15px' }}>
                            <div className="form-group">
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Năm hướng dẫn (*)</label>
                                <Calendar
                                    id="StartYear"
                                    name="StartYear"
                                    value={(formData.StartYear && !isNaN(new Date(formData.StartYear).getTime())) ? new Date(formData.StartYear) : null}
                                    view="month"
                                    dateFormat="mm/yy"
                                    showIcon
                                    onChange={(e) => handleDateChange('StartYear', e.value)}
                                    style={{ width: '100%' }}
                                    appendTo={document.body}
                                    panelStyle={{ marginTop: '5px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', borderRadius: '8px', zIndex: 99999 }}
                                    inputStyle={{ padding: '10px 12px', border: '1px solid #cbd5e1', borderRight: 'none', borderRadius: '6px 0 0 6px', fontSize: '14px', outline: 'none' }}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Năm tốt nghiệp (*)</label>
                                <Calendar
                                    id="GraduationYear"
                                    name="GraduationYear"
                                    value={(formData.GraduationYear && !isNaN(new Date(formData.GraduationYear).getTime())) ? new Date(formData.GraduationYear) : null}
                                    view="month"
                                    dateFormat="mm/yy"
                                    showIcon
                                    onChange={(e) => handleDateChange('GraduationYear', e.value)}
                                    style={{ width: '100%' }}
                                    appendTo={document.body}
                                    panelStyle={{ marginTop: '5px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', borderRadius: '8px', zIndex: 99999 }}
                                    inputStyle={{ padding: '10px 12px', border: '1px solid #cbd5e1', borderRight: 'none', borderRadius: '6px 0 0 6px', fontSize: '14px', outline: 'none' }}
                                    required
                                />
                            </div>
                        </div>
                    </form>
                </div>

                <div className="modal-footer" style={{ borderTop: '1px solid #eee', padding: '15px 25px' }}>
                    <button type="button" className="btn-cancel" onClick={onClose}>Hủy</button>
                    <button type="submit" form="mentoringForm" className="btn-submit">Hoàn tất</button>
                </div>
            </div>
        </div>
    );
};

export default ProfileMentoringForm;